module.exports = __webpack_public_path__ + "img/맥형아카데미_2_도입버튼.25af2b89.jpg";